<template>
  <div>
    <FlexRow>
      <FlexItem>
        <InputTextField v-model="source.url" label="Content URL" :help="apiDocs('clpp.Source#url')"/>
      </FlexItem>
      <FlexItem grow="0">
        <InputSelect v-model="source.type" label="Type"
                     :help="apiDocs('clpp.Source#type')"
                     :options="[
                       {value: null, label: 'Auto'},
                       {value: 'application/dash+xml', label: 'MPEG-DASH'},
                       {value: 'application/x-mpegurl', label: 'HLS'},
                       {value: 'application/vnd.ms-sstr+xml', label: 'Smooth Streaming'},
                       {value: 'video/mp4', label: 'MP4'},
                       {value: 'audio/mp3', label: 'MP3'},
                     ]"/>
      </FlexItem>
    </FlexRow>
  </div>
</template>

<script>
import InputTextField from '../../forms/InputTextField';
import { Docs } from '../../../utils/docs';
import FlexRow from '../../layout/FlexRow';
import FlexItem from '../../layout/FlexItem';
import InputSelect from '../../forms/InputSelect';

export default {
  name: 'PlayerConfigSourceConfig',
  components: { InputSelect, FlexItem, FlexRow, InputTextField },
  props: ['value'],
  data: () => ({
    source: {
      url: '',
      type: '',
      drmProtected: false
    }
  }),
  watch: {
    'value.drm': function (newValue) {
      this.source.drmProtected = !!(newValue && newValue.drm);
    },
    value: {
      immediate: true,
      handler (newVal) {
        if (!newVal || !newVal.source) {
          // the asset has no drm data
          this.source.url = '';
          this.source.type = '';
          newVal.source = this.source;
        } else if (newVal && typeof newVal.source === 'string') {
          this.source.url = newVal.source;
          this.source.type = clpp.utils.media.detectType(this.source.url);
          this.source.drmProtected = !!(newVal && newVal.drm && newVal.drm.env);
          newVal.source = this.source;
        } else {
          this.source = newVal.source;
          this.source.type = newVal.source.type ? newVal.source.type : clpp.utils.media.detectType(this.source.url);
          this.source.drmProtected = !!(newVal && newVal.drm && newVal.drm.env);
        }
      }
    }
  },
  methods: {
    apiDocs (field) {
      return Docs.getDescription(field);
    }
  }

};
</script>

<style scoped>

</style>
